const mockTags = [
  {
    id: 1,
    text: "Market"
  },
  {
    id: 2,
    text: "Product"
  },
  {
    id: 3,
    text: "News"
  },
  {
    id: 4,
    text: "Finance"
  },
  {
    id: 5,
    text: "Validation"
  },
  {
    id: 6,
    text: "Complex"
  },
  {
    id: 7,
    text: "House"
  }  
];

export default mockTags


// WEBPACK FOOTER //
// ./src/components/dashboard/mockTags.js